export const SET_MODAL = 'SET_MODAL';
export const SET_VIDEO_OVERLAY = 'SET_VIDEO_OVERLAY';
export const SET_STICKY_NAV_VISIBILITY = 'SET_STICKY_NAV_VISIBILITY';

export const setVideoOverlay = shouldShow => dispatch => dispatch({ type: SET_VIDEO_OVERLAY, payload: shouldShow });
export const setModal = payload => dispatch => dispatch({ type: SET_MODAL, payload });
export const setStickyNavVisiblity = shouldShow => dispatch => dispatch({ type: SET_STICKY_NAV_VISIBILITY, payload: shouldShow });



// WEBPACK FOOTER //
// ./src/state/actions/viewActions.js